var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.15154 8.66274L8.40714 9.40713C8.1823 9.63198 7.81775 9.63198 7.5929 9.40713L6.84851 8.66274L3.6306 11.8807L12.3677 11.8789L9.15154 8.66274ZM13.1819 4.63239L9.96578 7.84848L13.1817 11.0644L13.1819 4.63239ZM6.03426 7.8485L2.81835 4.63259L2.81818 11.0646L6.03426 7.8485ZM8.00002 8.20478L12.372 3.81634L3.62978 3.81812L8.00002 8.20478ZM2.81872 2.66666H13.1813C13.8176 2.66666 14.3334 3.1806 14.3334 3.81535V11.8816C14.3334 12.516 13.8172 13.0303 13.1813 13.0303H2.81872C2.18247 13.0303 1.66669 12.5164 1.66669 11.8816V3.81535C1.66669 3.18095 2.18288 2.66666 2.81872 2.66666Z","fill":"#1C232B"}));
}

Envelope.displayName = "Envelope";

Envelope.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
